The address of the location in a single formatted line.

Example: `60-88 Cremorne St, Cremorne VIC 3121, Australia`.
